import { useParams } from 'react-router-dom'
import { GoldReportPage } from './GoldReportPage'

export function StaffReportPage() {
  const { clubId, userId } = useParams()
  const path = clubId
    ? `/club/${clubId}/players/${userId}/report`
    : `/admin/athletes/${userId}/report`
  return <GoldReportPage reportPath={path} pdfPath={`${path}.pdf`} readOnly />
}
